function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Base",
  transform: "translate(-346.000000, -222.000000)",
  fill: "#C20000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-+-Label-Copy-24",
  transform: "translate(341.000000, 217.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-chevronLeft",
  transform: "translate(5.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M12.8913664,4.52433431 L4.52433431,12.8913664 C5.50499293,13.5894515 6.7045521,14 8,14 C11.3137085,14 14,11.3137085 14,8 C14,6.7045521 13.5894515,5.50499293 12.8913664,4.52433431 Z M8,2 C4.6862915,2 2,4.6862915 2,8 C2,9.2954479 2.41054847,10.4950071 3.1086336,11.4756657 L11.4756657,3.1086336 C10.4950071,2.41054847 9.2954479,2 8,2 Z",
  id: "Shape"
})))));

function SvgDaxNotAvailableIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / NotAvailable") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaxNotAvailableIcon);
export default __webpack_public_path__ + "static/media/dax-notAvailableIcon.97a4262a.svg";
export { ForwardRef as ReactComponent };